<button
  #toggleButton
  type="button"
  class="nhsuk-link settings-toggle"
  aria-label="Settings"
  aria-haspopup="dialog"
  [attr.aria-expanded]="isOpen()"
  (click)="open()"
>
  <svg
    class="settings-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="20"
    height="20"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="currentColor"
      d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65a.5.5 0 0 0 .12-.64l-2-3.46a.5.5 0 0 0-.61-.22l-2.49 1a7.3 7.3 0 0 0-1.69-.98l-.38-2.65A.49.49 0 0 0 14 2h-4a.49.49 0 0 0-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1a.5.5 0 0 0-.61.22l-2 3.46a.5.5 0 0 0 .12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65a.5.5 0 0 0-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.04.24.24.42.49.42h4c.25 0 .45-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46a.5.5 0 0 0-.12-.64l-2.11-1.65ZM12 15.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Z"
    />
  </svg>
</button>

@if (isOpen()) {
  <div class="settings-backdrop" (click)="close()" aria-hidden="true"></div>
  <section
    class="settings-panel"
    role="dialog"
    aria-modal="true"
    aria-labelledby="settings-panel-title"
  >
    <div class="settings-panel__header">
      <h2 id="settings-panel-title" class="nhsuk-heading-m mb-0">Settings</h2>
      <button
        #closeButton
        type="button"
        class="settings-panel__close"
        aria-label="Close settings"
        (click)="close()"
      >
        <svg
          class="nhsuk-icon nhsuk-icon__close"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
          width="24"
          height="24"
        >
          <path
            d="M13.41 12l5.3-5.29a1 1 0 1 0-1.42-1.42L12 10.59l-5.29-5.3a1 1 0 0 0-1.42 1.42l5.3 5.29-5.3 5.29a1 1 0 0 0 1.42 1.42l5.29-5.3 5.29 5.3a1 1 0 0 0 1.42-1.42z"
          ></path>
        </svg>
      </button>
    </div>

    <div class="nhsuk-form-group">
      <fieldset class="nhsuk-fieldset">
        <legend class="nhsuk-fieldset__legend nhsuk-fieldset__legend--s">
          <span class="nhsuk-fieldset__heading">Page width</span>
        </legend>
        <div class="nhsuk-hint">How wide the page content can stretch on large screens.</div>
        <div class="nhsuk-radios">
          @for (option of widthOptions; track option.value) {
            <div class="nhsuk-radios__item">
              <input
                class="nhsuk-radios__input"
                type="radio"
                name="app-width"
                [id]="'app-width-' + option.value"
                [value]="option.value"
                [checked]="appWidth === option.value"
                (change)="selectWidth(option.value)"
              />
              <label class="nhsuk-label nhsuk-radios__label" [for]="'app-width-' + option.value">
                {{ option.label }}
              </label>
            </div>
          }
        </div>
      </fieldset>
    </div>
  </section>
}
